import fc_varmdo from '../images/flowcharts/varmdo-bygglov.png'

export function getImageByRef(ref: string | undefined) {
    if (! ref) return undefined
    return fc_varmdo
}